export const AxiosReturnTypes = {
    ValidationError: "https://tools.ietf.org/html/rfc7231#section-6.5.1"
}